import { render } from "./App.vue?vue&type=template&id=2654da30"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2654da30&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_3ca827165d99699ca1e09c2bcd03c6d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__